import React from 'react';
import {connect} from 'react-redux';
import FolderExplorerNew from '../../forms/FolderExplorerNew';

function SelectDestinationView(props) {
  const {dispatch, storageManager, selectedFolder, setSelectedFolder} = props;
  const {currentView, openedFoldersInModal, foldersInModal, loaders} = storageManager;
  return (
    <FolderExplorerNew
      dispatch={dispatch}
      loaders={loaders}
      folders={foldersInModal}
      openedFolders={openedFoldersInModal}
      currentView={currentView}
      selectedFolder={selectedFolder}
      onSelectFolder={setSelectedFolder}
      storageManager={storageManager}
    />
  );
}

function mapStateToProps(state) {
  return {
    storageManager: state.storageManager,
  };
}

export default connect(mapStateToProps)(SelectDestinationView);